import { Box, Chip, MenuItem, Select, FormControl } from '@mui/material';
import { FC } from 'react';
import { useGetBoardColumnsQuery } from 'redux/apiSlices/board.slice';
import { ITaskUI } from 'data/types/task.type';
import { useUpdateTaskStatusMutation } from 'redux/apiSlices/tasks.slice';

const TaskStatus: FC<{
  task: ITaskUI;
}> = ({ task }) => {
  const [updateTaskStatus] = useUpdateTaskStatusMutation();
  const { data: columns } = useGetBoardColumnsQuery({
    boardId: task.boardId,
    projectId: task.projectId,
  });

  const onStatusChange = (newColumnId: string) => {
    updateTaskStatus({
      task,
      destinationColumnId: newColumnId,
      destinationIndex: 0,
    });
  };

  const currentColumn = columns?.find(c => c.documentId === task.columnId);

  return (
    <>
      {!!columns?.length && (
        <FormControl fullWidth size="small">
          <Select
            value={task.columnId}
            onChange={e => onStatusChange(e.target.value)}
            sx={{
              backgroundColor: 'background.paper',
              '& .MuiSelect-select': {
                py: 1,
              },
            }}
            renderValue={() => (
              <Chip
                label={currentColumn?.title || 'Select status'}
                size="small"
                sx={{
                  bgcolor: currentColumn?.color || 'grey.200',
                  color: 'text.primary',
                  fontWeight: 500,
                  height: 26,
                }}
              />
            )}
          >
            {columns.map(column => (
              <MenuItem key={column.documentId} value={column.documentId}>
                <Chip
                  label={column.title}
                  size="small"
                  sx={{
                    bgcolor: column.color,
                    color: 'text.primary',
                    fontWeight: 500,
                    width: '100%',
                    justifyContent: 'flex-start',
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default TaskStatus;
